import { Divider, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { MessageIconCover } from "../UIElements/svgIcons";
import { JobEmpStatus } from "./JobTable";

const JobStats = ({ stats }: any) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 3}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total active jobs"}
            value={stats?.totalJobs}
            icon={<MessageIconCover />}
          />
        </Grid>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 3}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total application for active jobs"}
            value={stats.totalApplicants}
            icon={<MessageIconCover />}
          />
        </Grid>{" "}
        {/* <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 3}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Pending Reviews"}
            value={stats.totalPendingReviews}
            icon={<MessageIconCover />}
          />
        </Grid>{" "} */}
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 3}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Upcoming Interviews"}
            value={stats.totalUpcomingInterviews}
            icon={<MessageIconCover />}
          />
        </Grid>
      </Grid>
      
    </>
  );
};

export default JobStats;
